exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".carrot-up-white {\n  fill:#fff\n}\n\n.carrot-up-black {\n  fill:black\n}", ""]);
